import { useIntl } from 'react-intl';
import { ProductAmount } from 'types/ProductData';
import {
  calculateBasePrice,
  isRenderablePrice,
} from 'utils/productTotalPriceHelper';
import useMarketType from 'utils/useMarketType';

interface ProductCardPriceProps {
  productAmount?: ProductAmount;
  amount?: number;
}

export const ProductCardPrice = ({
  productAmount,
  amount = 0,
}: ProductCardPriceProps) => {
  const intl = useIntl();
  const { isEmarket } = useMarketType();

  if (!productAmount) return null;

  const { changedBasePrice, storageStockDiscountPrice } = calculateBasePrice(
    productAmount,
    amount
  );

  const priceRanges = productAmount.wholesale_price_ranges ?? [];
  const lowestRangePrice = priceRanges.length
    ? parseFloat(
        priceRanges.reduce((min, item) =>
          parseFloat(item.price) < parseFloat(min.price) ? item : min
        ).price
      )
    : null;

  const showLowestRangePrice = lowestRangePrice !== null && amount <= 0;
  const basePrice = showLowestRangePrice ? lowestRangePrice : changedBasePrice;

  if (!isRenderablePrice(basePrice)) return null;

  const hasDiscount =
    isRenderablePrice(storageStockDiscountPrice) &&
    storageStockDiscountPrice > 0 &&
    storageStockDiscountPrice < basePrice;
  const currentPrice = hasDiscount ? storageStockDiscountPrice : basePrice;

  const unitPrice = Number(productAmount.package_unit_price);
  const showUnitPrice = productAmount.storage_unit === 'iep' && unitPrice > 0;

  return (
    <div className={'product-card-price'}>
      <div className={`price-current${hasDiscount ? ' discounted' : ''}`}>
        {!isEmarket &&
          showLowestRangePrice &&
          `${intl.formatMessage({ id: 'general.from' })} `}
        {currentPrice.toFixed(2)} <span className={'price-currency'}>€</span>
        {!!productAmount.storage_unit && (
          <span className={'price-unit'}>/{productAmount.storage_unit}</span>
        )}
      </div>
      {(hasDiscount || showUnitPrice) && (
        <div className={'price-details'}>
          {hasDiscount && (
            <div className={'price-old'}>
              {basePrice.toFixed(2)} € /{productAmount.storage_unit}
            </div>
          )}
          {showUnitPrice && (
            <div className={'price-per-unit'}>
              {unitPrice.toFixed(2)} € /{productAmount.package_unit}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
